import React from 'react';

const GameOverviewRules = () => {
  const coins = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;
  const winPoints = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/win points.png'}
    alt={'Очки'}
    title={'Очки'}
  />;
  const initiative = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/initiative.png'}
    alt={'Инициатива'}
    title={'Инициатива (право первого хода в фазе)'}
  />;
  const flag = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/flag.png'}
    alt={'Флаг'}
    title={'Стартовый флаг игрока'}
  />;
  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;
  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  const hammer = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/hammer brown.png'}
    alt={'Строительство'}
    title={'Строительство'}
  />;
  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const melee = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;
  const city = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-primary">
        Стратегикон — правила игры
      </h2>

      <p className="rules-page_quote">
        Умение хорошо играть — признак великого ума.<br/>
        Блез Паскаль
      </p>

      {/*<div className="rules-page_section">
        <p className={'rules-page_preamble'}>
          <span className={'text-primary'}>Стратегикон</span> — это не просто игра.
          Это <span className={'text-attention'}>интеллектуальный тренажер, в котором Вы овладеете навыками, необходимыми любому руководителю:</span>
          {' '}стратегическое планирование и тактическое управление.
          <br/>Игра заставит вас развить в себе умение принимать оперативные решения и внимательность к деталям.
          <br/>И наглядно покажет, почему <span className={'text-primary'}>управление государством — сложнейшая задача в условиях конкуренции</span> на геополитической арене.
        </p>
        <p className={'rules-page_preamble'}>
          Но и заскучать <span className={'text-primary'}>Стратегикон</span> не даст: полная свобода действий, многообразие фракций и политик, постоянная конкуренция с живыми игроками — каждая партия уникальна.
        </p>
        <p className={'rules-page_preamble'}>
          <span className={'text-attention'}>Матчи проходят быстро:</span> например, среднее время партии на 3 игроков всего 45 минут. Вы можете регулировать количество соперников, чтобы управлять длительностью матча.
        </p>
        <p className={'rules-page_preamble'}>
          <span className={'text-attention'}>Правила, изложенные ниже, очень интуитивны на практике:</span> большинство игроков уже после первой партии показывают себя уверенными Стратегами. А дальше — только Ваша сообразительность.
        </p>
      </div>*/}

      <div className="rules-page_section">
        <p>
          Матчи проходят на поле из гексагональных ячеек.
          <br/>Изначально на поле размещены только ключевые точки (рудники и руины), горы (непроходимые ячейки) и
          стартовые
          города.
          <br/>В свои ходы игроки размещают на поле строения, распределяют снабжение, нанимают и перемещают
          отряды {unit}, захватывают ключевые точки и города противников.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Цель игры</h2>
        <p>
          Побеждает игрок, который за <b>13 раундов</b> заработал наибольшее количество очков {winPoints}.
        </p>
        <p>
          В конце игры непотраченные монеты {coins} игроков переводятся в очки {winPoints} по курсу <b>2 к 1</b>.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Подготовка к игре</h2>
        <p>
          Перед началом матча каждый игрок в тайне от соперников выбирает одну из доступных ему фракций, за которую
          будет играть весь матч.
        </p>
        <p>
          <span className={'text-primary'}>В рейтинговой игре выбор ограничен 4 случайными фракциями</span> из перечня
          всех открытых игроку.
        </p>
        <h3>В момент старта матча:</h3>
        <ol>
          <li>Случайно выбирается одно из полей, соответствующее количеству игроков в матче.</li>
          <li>Каждый игрок получает <b className={'text-coins-dark'}>15 монет</b> {coins}.</li>
          <li>Случайному игроку достается <b className={'text-success'}>инициатива</b> {initiative} — право первого хода
            в каждой фазе игры (кроме фазы Снабжения в сетевой игре — в ней все игроки ходят одновременно).
          </li>
        </ol>
      </div>

      <div className="rules-page_section">
        <h2>Ход игры</h2>

        <h3>Начало игры</h3>
        <p>
          В начале матча все игроки одновременно и втайне друг от друга (выбор ячейки не отображается противникам)
          выставляют стартовый <span className={'text-construction'}>Центральный квартал</span> {centralQuarter} на
          любой ячейке поля, которая помечена
          стартовым флагом {flag} игрока соответствующего цвета.
        </p>

        <h3>Раунд</h3>
        <p>Далее игра проходит по раундам. Раунд состоит из 3 фаз:</p>
        <ol>
          <li className={'text-supply'}>Фаза Снабжения {supply}</li>
          <li className={'text-construction'}>Фаза Строительства {hammer}</li>
          <li className={'text-war'}>Фаза Войны {melee}</li>
        </ol>
        <p>
          Все игроки сначала выполняют <b className={'text-supply'}>фазу Снабжения</b>. В сетевой игре ходы в ней идут
          одновременно: все игроки распределяют снабжение своим отрядам в одно и то же время, а результат (изменение
          размеров отрядов) применяется ко всем игрокам единовременно — только когда фазу Снабжения завершат все игроки.
          В локальной игре, обучении и сюжетной кампании фазу Снабжения игроки выполняют по очереди
          (начиная с владельца <b className={'text-success'}>инициативы</b> {initiative}).
        </p>
        <p>
          Далее по очереди (начиная с владельца <b className={'text-success'}>инициативы</b> {initiative}) все
          выполняют <b className={'text-construction'}>фазу Строительства</b>. А после —
          <b className={'text-war'}> фазу Войны</b>.
        </p>
        <p>
          В конце раунда происходит проверка захвата городов {city} (и смена владельцев при выполнении условий захвата).
          После чего
          игроки получают доход монет {coins} и очков {winPoints}, а у игроков, не имеющих ни одного города {city},
          монеты сгорают. Затем наступает следующий раунд.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Термины</h2>
        <ul>
          <li><b>Смежная ячейка</b> — соседняя ячейка, имеющая общую сторону с той ячейкой, которую занимает объект
            (например, отряд или строение).
          </li>
          <li><b>Зона контроля отряда</b> (ЗК отряда) — занимаемая отрядом ячейка, а также смежные ей ячейки.</li>
          <li><b>Пустая ячейка</b> — ячейка, на которой нет ни обычного строения, ни ключевой точки, ни горы. На
            пустой ячейке при этом может находиться отряд — ячейка при этом все равно называется пустой.
          </li>
          <li><b>Дальность</b> — количество ячеек от одной ячейки до другой, не считая саму ячейку, от которой
            происходит расчет. То есть, если кратчайший путь между двумя ячейками проходит, например, через 3 другие
            ячейки между ними, то дальность считается равной 4.
          </li>
          <li><b>Отряд противника</b> — любой отряд {unit}, который не принадлежит игроку, в том числе нейтральный.
            Свои отряды не создают игроку зоны контроля: не запрещают ему строить, не перекрывают его пути снабжения и
            не блокируют его строения.
          </li>
        </ul>
      </div>

      <div className="rules-page_section">
        <h2>Зона контроля отрядов противника</h2>
        <p>Зона контроля (ЗК) отряда противника, в частности:</p>
        <ul>
          <li><b>Строительство {hammer}.</b> В ЗК отряда противника нельзя строить — ни на ячейке, где стоит отряд,
            ни на смежных с ней. Путь строительства через ЗК противника тоже не проходит (подробнее — в разделе
            «Фаза Строительства»).
          </li>
          <li><b>Снабжение {supply}.</b> Путь снабжения не проходит через ЗК противника (подробнее — в разделе
            «Фаза Снабжения»).
          </li>
          <li><b>Блокировка.</b> Строения и ключевые точки в ЗК отряда противника заблокированы — см. ниже.</li>
          <li><b>Крепость и стрельба.</b> Крепость в ЗК противника не достраивается, а катапульта не может стрелять,
            если смежно с ней стоит отряд противника (подробнее — в разделе «Для опытных игроков»).
          </li>
        </ul>
        <p>ЗК противника ограничивает и некоторые способности фракций — см. их описания.</p>

        <h3>Блокировка строений и ключевых точек</h3>
        <p>
          Строение или ключевая точка заблокированы, если на них или смежно с ними стоит отряд противника — в том
          числе нейтральный. Ферма, казарма и ключевые точки, кроме того, заблокированы, когда заблокированы или
          повреждены все смежные с ними кварталы владельца. Поэтому отряд может заблокировать их и издалека — встав
          рядом с кварталом, который их поддерживает.
        </p>
        <p>Заблокированные строения и ключевые точки не работают:</p>
        <ul>
          <li>ключевые точки, гильдии и храмы не приносят дохода {coins}{winPoints};</li>
          <li>ферма не производит снабжение, склад не удваивает его соседним фермам;</li>
          <li>на казарме нельзя нанимать, улучшать отряды и докупать им размер, а отряд на ней растет в фазе
            Снабжения как на обычной ячейке; лагерь и арсенал не дают своих бонусов;
          </li>
          <li>дворец не дает дополнительного действия в фазе Строительства;</li>
          <li>квартал не дает докупки размера отрядам, не поддерживает смежные фермы, казармы и ключевые точки и не
            годится под специальное строение.
          </li>
        </ul>
        <p>
          Блокировка не меняет владельца: город {city}, его строения и ключевые точки остаются за ним. Отнять город
          можно только захватом (см. раздел «Очки за действия»). Доход считается по положению отрядов на конец
          раунда.
        </p>
        <p>
          Сама крепость отрядами не блокируется (но в ЗК противника не достраивается), а строение или ключевая точка
          под ней блокируются как обычно. Поврежденные строения тоже не работают (см. раздел «Для опытных игроков»),
          но путь строительства через них проходит.
        </p>
      </div>
    </div>
  );
};

export default GameOverviewRules;
